module.exports = __webpack_public_path__ + "static/media/mars-stroke-h.5a9b6f06.svg";